import { useTranslation } from 'next-i18next';
import Carousel, { Room } from '../priceList/Carousel';
import fantazie1 from '@/public/img/rooms/fantazie/1.jpg';
import fantazie2 from '@/public/img/rooms/fantazie/2.jpg';
import nebe1 from '@/public/img/rooms/nebe/1.jpg';
import nebe2 from '@/public/img/rooms/nebe/2.jpg';
import kuchyn from '@/public/img/rooms/kuchyn.jpg';
import vip_koupelna from '@/public/img/rooms/vip/koupelna.jpg';
import vip_zachod from '@/public/img/rooms/vip/zachod.jpg';
import standard_koupelna from '@/public/img/rooms/standard/koupelna.jpg';
import standard_zachod from '@/public/img/rooms/standard/zachod.jpg';
import peklo1 from '@/public/img/rooms/peklo/1.jpg';
import peklo2 from '@/public/img/rooms/peklo/2.jpg';
import sen1 from '@/public/img/rooms/sen/1.jpg';
import sen2 from '@/public/img/rooms/sen/2.jpg';
type Props = {
  type: string;
};
const PriceListHero = ({ type }: Props) => {
  const { t } = useTranslation('priceList');

  const standardData: Array<Room> = [
    {
      name: t('rooms.sen'),
      // @ts-ignore
      image: sen1,
    },
    {
      name: t('rooms.sen'),
      // @ts-ignore
      image: sen2,
    },
    {
      name: t('rooms.fantazie'),
      // @ts-ignore
      image: fantazie1,
    },
    {
      name: t('rooms.fantazie'),
      // @ts-ignore
      image: fantazie2,
    },
    {
      name: t('rooms.standard.koupelna'),
      // @ts-ignore
      image: standard_koupelna,
    },
    {
      name: t('rooms.kuchyn'),
      // @ts-ignore
      image: kuchyn,
    },
    {
      name: t('rooms.standard.wc'),
      // @ts-ignore
      image: standard_zachod,
    },
  ];
  const vipData: Array<Room> = [
    {
      name: t('rooms.peklo'),
      // @ts-ignore
      image: peklo1,
    },
    {
      name: t('rooms.peklo'),
      // @ts-ignore
      image: peklo2,
    },
    {
      name: t('rooms.nebe'),
      // @ts-ignore
      image: nebe1,
    },
    {
      name: t('rooms.nebe'),
      // @ts-ignore
      image: nebe2,
    },
    {
      name: t('rooms.vip.koupelna'),
      // @ts-ignore
      image: vip_koupelna,
    },
    {
      name: t('rooms.kuchyn'),
      // @ts-ignore
      image: kuchyn,
    },
    {
      name: t('rooms.vip.wc'),
      // @ts-ignore
      image: vip_zachod,
    }
  ];
  if (type === 'standard') {
    return (
      <section className='bg-[#131313] py-20 mb-20'>
        <div className='container px-4 mx-auto flex flex-col items-start justify-between lg:flex-row lg:items-center'>
          <div className='mb-8 lg:mb-0 lg:mr-4 w-full'>
            <h1 className={`text-white text-[32px] flex items-center mb-10 font-semibold`}>
              <svg className='mr-4' width='56' height='2' viewBox='0 0 56 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <line x1='8.74228e-08' y1='1' x2='56' y2='1' stroke='#F0B10D' strokeWidth='2' />
              </svg>
              {t('hero.title')}
            </h1>
            <p className='text-white max-w-lg'>{t('hero.text')}</p>
          </div>
          <Carousel data={standardData}></Carousel>
        </div>
      </section>
    );
  } else if (type === 'VIP') {
    return (
      <section className='bg-[#131313] py-20 mb-20'>
        <div className='container px-4 mx-auto flex flex-col items-start justify-between lg:flex-row lg:items-center'>
          <div className='mb-8 lg:mb-0 lg:mr-4 w-full'>
            <h1 className={`text-white text-[32px] flex items-center mb-10 font-semibold`}>
              <svg className='mr-4' width='56' height='2' viewBox='0 0 56 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <line x1='8.74228e-08' y1='1' x2='56' y2='1' stroke='#F0B10D' strokeWidth='2' />
              </svg>
              {t('vipRooms.title')}
            </h1>
            <p className='text-white max-w-lg'>{t('vipRooms.text')}</p>
          </div>
          <Carousel data={vipData}></Carousel>
        </div>
      </section>
    );
  } else {
    return <></>;
  }
};

export default PriceListHero;
